module.exports = __webpack_public_path__ + "img/dt-logo-white-text.74c0e8bd.svg";